import { SortFilter } from '@enums/sortFilter';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class SelectedFilterService {
  selectPriceOrDateFilter(selectedFilterValue: SortFilter): boolean {
    let priceFilterSelected: boolean;
    switch (selectedFilterValue) {
      case SortFilter.menorPrecio:
        priceFilterSelected = true;
        break;

      case SortFilter.mayorPrecio:
        priceFilterSelected = true;
        break;

      case SortFilter.masRecientes:
        priceFilterSelected = false;
        break;

      case SortFilter.masAntiguas:
        priceFilterSelected = false;
        break;

      default:
        priceFilterSelected = true;
        break;
    }
    return priceFilterSelected;
  }

  getOrderBySelectedFilter(selectedFilterValue: SortFilter): string {
    let orderBy: string;

    switch (selectedFilterValue) {
      case SortFilter.menorPrecio:
        orderBy = 'asc';
        break;

      case SortFilter.mayorPrecio:
        orderBy = 'desc';
        break;

      case SortFilter.masRecientes:
        orderBy = 'desc';
        break;

      case SortFilter.masAntiguas:
        orderBy = 'asc';
        break;

      default:
        orderBy = 'asc';
        break;
    }

    return orderBy;
  }
}
